<template>
  <div class="page-main page-btns">
    <div class="page_top">
      <div class="name">
        Hi,{{ recipientName }}
        <el-button type="text" v-if="+$store.getters.userInfo.type === 0" @click="handleUpdate">Modify</el-button>
      </div>
      <div class="send">
        <el-button v-if="+$store.getters.userInfo.type === 0" type="primary" @click="toSend">
          <svg-icon icon-class="tn-msg" />
          Send
        </el-button>
        <el-button v-else type="primary" @click="toSend">
          <svg-icon icon-class="tn-msg" />
          Send to Producer
        </el-button>
      </div>
    </div>
    <div class="home-msg" v-loading="loading">
      <div class="home-msg_title spaceBetween">
        Message List
        <div>
          <el-checkbox v-model="hideReaded" @change="getDataList">Hide read</el-checkbox>
          <loading-btn type="text" @clickHandle="markAllRead" style="margin-left: 16px" label="Mark all as read">
            <svg-icon icon-class="tn-readed" />
          </loading-btn>
        </div>
      </div>
      <el-collapse accordion class="home-msg_collapse" @change="changeOpen" v-model="activeCollapse">
        <el-collapse-item v-for="(item, index) in dataList" :key="index" :class="{ 'is-readed': +item.status !== 0 }"
          :name="item.msgID">
          <template slot="title">
            <div class="spaceBetween home-msg_collapse_head">
              <div>
                <svg-icon icon-class="tn-jiantou" class="icon-arrow" />
                <span>{{ item.title }}</span>
              </div>
              <span class="time-text">{{ moment(item.timestamp).fromNow() }}</span>
            </div>
          </template>
          <pre class="msg-desc">
  <p v-html="item.description"></p>
</pre>
        </el-collapse-item>
      </el-collapse>
      <div class="msg-empty" v-if="dataList.length == 0">No Data</div>
      <div class="table-bottom-btn">
        <pagination :total="queryParams.total" :page.sync="queryParams.page" :limit.sync="queryParams.eachpage"
          @pagination="getDataList()" />
      </div>
    </div>
    <updateName ref="updateName" @success="setSuccess"></updateName>
  </div>
</template>

<script>
import { messageList, readed } from "@/api/message.js";
import { getInfo } from "@/api/login.js";
import updateName from "./updateName.vue";
export default {
  components: {
    updateName,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      hideReaded: false,
      queryParams: {
        total: 0,
        page: 1,
        eachpage: 10,
      },
      activeCollapse: undefined,
      recipientName: "",
    };
  },
  computed: {},
  methods: {
    async getDataList() {
      this.loading = true;
      const param = {
        page: this.queryParams.page,
        eachpage: this.queryParams.eachpage,
        hideRead: this.hideReaded || undefined,
      };
      try {
        let res = await messageList(param)
        this.dataList = res.result.list;
        console.log(this.dataList)
        this.loading = false;
        this.queryParams.total = res.result.total || 0;
      } catch (error) {
        console.log(error)
        this.loading = false;
      }
    },
    changeOpen(data) {
      this.readed();
    },
    readed() {
      let item = this.dataList.find((i) => i.msgID == this.activeCollapse);
      if (item && +item.status === 0) {
        readed({ msgID: this.activeCollapse }).then((res) => {
          item.status = 1;
        });
      }
    },
    toSend() {
      this.$router.push("/messages/send");
    },
    markAllRead(btn) {
      readed()
        .then((res) => {
          btn.closeLoad();
          this.$message.success("Mark successful!");
        })
        .catch((err) => {
          btn.closeLoad();
        });
    },
    handleUpdate() {
      this.$refs.updateName.show();
    },
    setSuccess() {
      getInfo().then((res) => {
        this.recipientName = res.result.recipientName;
      });
    },
  },
  created() {
    this.recipientName = this.$store.getters.userInfo.recipientName;
    // console.log(this.$store.getters.userInfo)
    this.getDataList();
    // let n = this.moment('2021-11-24T08:16:12.507Z').fromNow();
    // console.log(n)
  },
};
</script>
<style scoped lang="scss">
.page_top {
  display: flex;
  justify-content: space-between;

  .name {
    font-size: 0.26rem;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.4rem;
  }
}

.home-msg {
  margin-top: 0.32rem;
  background: #fff;
  border-radius: 4px;

  ::v-deep .el-checkbox__label {
    font-size: 0.18rem;
  }

  .home-msg_title {
    font-size: 0.22rem;
    color: #262626;
    padding: 0.24rem 0.32rem;
    font-weight: 500;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 4px;
  }

  .home-msg_collapse {
    padding: 0 0.32rem 0.24rem 0.32rem;
    border: none;

    ::v-deep .el-collapse-item__header {
      background: #fafafa !important;
      border-bottom: none;
      color: #000;
      font-weight: bold;
      font-size: 0.18rem;
      padding: 0.24rem 0.32rem;

      &.is-active {
        .icon-arrow {
          transform: rotate(90deg);
          display: inline-block;
        }
      }
    }

    ::v-deep .el-collapse-item__content {
      background: #fafafa !important;
      border-bottom: none;
      font-size: 0.18rem;
      color: #575757;
      padding: 0 0.32rem 0.24rem 0.32rem;
    }

    ::v-deep .el-collapse-item__wrap {
      border-bottom: none;
    }

    .el-collapse-item {
      margin-bottom: 12px;
    }

    ::v-deep .el-collapse-item__arrow {
      display: none;
    }

    .home-msg_collapse_head {
      width: 100%;

      .time-text {
        color: #a3a3a3;
        font-weight: normal;
      }
    }

    .is-readed {
      opacity: 0.6;
    }
  }
}

.right-btn {
  float: right;
}

.msg-empty {
  color: #999;
  font-size: 0.18rem;
  text-align: center;
  padding: 0.24rem;
}

.msg-desc {
  font-size: 0.18rem;
  margin: 0;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
}
</style>
